/* Stylesheet */

.cohort_list_container {
  height: 100%;

  .cohort_list {
    min-height: 100%;
    background: var(--ion-gradient-light);
    border-radius: 0px 0px 5px 5px;
  }
}
